<template>
  <!--头部导航开始-->
  <el-header style="height:50px;width:100%;padding: 0 10px;">
    <div style="display: flex;align-items: center;width: 200px;position: absolute;">
      <div class="enklogo" style="height: 50px; background-position: left center; background-repeat: no-repeat ;"></div>
      <div style="width: 1px;height: 19px;background: #D1D2D4;opacity: 0.4;margin-top: 6px;"></div>
      <span style="font-weight: bold;font-size: 14px;color: #FFFFFF;position: absolute;top: 6px;left: 96px;">唐吉后台</span>
    </div>
    <!-- 顶部菜单 -->
    <div class="topmenu" style="width:85%; color: #fff;float: left;margin-left:210px;">
      <el-menu :default-active="$route.path" class="l_accountTopNav_menu" mode="horizontal"
        background-color="#111111" text-color="#ffffff" active-text-color="#409dfe">
        <el-menu-item v-for="item in menuList" :key="item.id" :index="item.path" :class="$route.path == item.path ? 'is-active' : ''" @click="selectMenu(item.name, item.path)">
          <span style="font-size: 14px;">{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 未读数 -->
    <!-- <div style="width: 100px; display: flex; align-items: center; justify-content: space-around; margin-top: 5px;" v-if="accid">
      <div v-if="is_chat_unread" @click="openChat">
        <img src="@/assets/image/notice.png" alt="" />
        <div style="position: absolute; top: -15px;">
          <el-badge v-if="chat_unread > 0 && chat_unread < 99" class="mark" :value="chat_unread"> </el-badge>
          <el-badge v-if="chat_unread >= 99" class="mark" value="99+"> </el-badge>
        </div>
      </div>
      <span v-if="is_chat_unread" style="margin-left: 10px;cursor: pointer;">
        <img v-if="is_open_audio" @click="pauseNotionAudio" src="@/assets/open_audio.png" alt="">
        <img v-else @click="playNotionAudio" src="@/assets/close_audio.png" alt="">
      </span>
    </div> -->
    <!-- 退出登录 -->
    <el-dropdown @command="handleCommand" style="width:auto;text-align:right;float:right;padding-right: 0px;color:#ffffff">
      <span class="el-dropdown-link">
        <i class="menuicon"><img src="@/images/person.png"></i>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="1">{{phone}}</el-dropdown-item>
        <el-dropdown-item command="2">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-header>
  <!--头部导航结束-->
</template>

<script>
  import Vue from "vue";
  import nim from '@/config/nim'; // nim配置文件
  import { mapGetters, mapMutations, mapState } from "vuex";
  import { PostData } from "@/api/fetchdata";
  import { getStorage, removeStorage } from "@/service/auth.js";
  export default {
    data() {
      return {
        phone: '',
        accid: getStorage('accid'),
        fromFullPath: getStorage('fromFullPath'),
        topNavIndex: window.sessionStorage['topNavIndex'] || this.$route.path,
        menuList:this.$store.state.menuList,
        routerListNew:this.$store.state.routerListNew,
        is_chat_unread: false,
        is_open_audio: false, // 是否开启声音提示
      };
    },
    props: ['index'],
    computed: {
      ...mapState(["chat_unread"]),
    },
    watch: {
    '$store.state.chatNotionMsg': 'showChatNotionMsg',
    '$route.path': {
      handler(newValue, oldValue) {
        this.topNavIndex = newValue;
        window.sessionStorage['topNavIndex'] = newValue;
      },
      deep: true,
      immediate: true
    },
  },
    created() {
      window.addEventListener("beforeunload",()=>{
        let path = this.$route.path
        sessionStorage.setItem('beforeunload-path',JSON.stringify(path))
      })
    },
    mounted() {
      PostData({
        service: 'User.Login.GetUserInfo',
        microservices: 'user',
      }).then(res => {
        if (res.data.ret === 200) {
          this.phone = res.data.data.phone;
        }
      }).catch(error => console.log(error));
      // 判断是否有客服模块
      this.isChatUnread();
      if(this.is_chat_unread && (!Vue.prototype.nim || Vue.prototype.nim && !Vue.prototype.nim.account)) {
        nim();
      }
      let pagePath = this.$route.path
      let path = JSON.parse(sessionStorage.getItem('beforeunload-path'));
      let is_open_audio = JSON.parse(sessionStorage.getItem('is_open_audio'));
      // 判断如果是刷新则关闭声音提示，不是刷新的话就先判断是否开启了声音提示，如果开启了需要把is_open_audio设置为true就可以。
      if (pagePath === path) {
        if(is_open_audio) {
          this.is_open_audio = true;
        } else {
          this.pauseNotionAudio();
        }
        sessionStorage.removeItem('beforeunload-path') // 判断完之后，移除刷新时缓存的路由，以免造成对其他页面的路由影响
      } else {
        if(is_open_audio){
          this.is_open_audio = true;
        } else {
          this.pauseNotionAudio();
        }
      }
      // 如果有accid，代表是客服，默认开启提示音
      if(this.accid && this.fromFullPath == '/login') {
        this.playNotionAudio();
      }
    },
    methods: {
      playNotionAudio() {
        const audio = document.getElementById('notionAudio');
        if (audio) {
          audio.play().then(() => {
            console.log('播放成功');
            this.is_open_audio = true;
            sessionStorage.setItem('is_open_audio',this.is_open_audio);
          }).catch(function(error) {
            console.log("播放失败，用户需要进行交互以播放音频: ", error);
          });
        } 
      },
      pauseNotionAudio() {
        const audio = document.getElementById('notionAudio');
        if (audio) {
          audio.pause();
          audio.load();
          this.is_open_audio = false;
          sessionStorage.setItem('is_open_audio',this.is_open_audio);
        } 
      },
      showChatNotionMsg() {
        if(this.is_open_audio) {
          this.playNotionAudio();
        }
      },
      isChatUnread(){      
        this.$store.state.menuList[0].children.some(item => {
          if (item.name === '客服管理') {
            if (item.children && item.children.length) {
              item.children.some(childItem => {
                if (childItem.name === '在线客服') {
                  this.is_chat_unread = true;
                  return true; // 找到'在线客服'，中断循环
                } else {
                  this.is_chat_unread = false;
                }
                return false; // 继续循环
              });
            }
            return true; // 找到'客服管理'，中断循环
          } else {
            this.is_chat_unread = false;
          }
          return false; // 继续循环
        });
      },
      openChat() {
        // 顶部侧菜单key
        window.sessionStorage['topNavIndex'] = '/onlineCustomerService';
        // 左侧菜单key
        window.sessionStorage['leftNavIndex'] = '/onlineCustomerService';
        // 用于循环左侧菜单的下标
        window.sessionStorage['leftMenuShowHide'] = 0;
        // 控制左侧菜单显隐
        window.sessionStorage['topMenuId'] = 560;
        this.$store.commit('SET_MENU_LIST', '/onlineCustomerService');
        this.$router.push('/onlineCustomerService');
      },
      selectMenu(name, key) {
        let menuList = JSON.parse(getStorage('menuList'));
        this.$store.dispatch('get_menu_list',menuList);
        menuList.map((item, index) => {
          if(item.name == name) {
            window.sessionStorage['topNavIndex'] = item.path;
            window.sessionStorage['leftMenuShowHide'] = index;
            window.sessionStorage['topMenuId'] = item.id;
            this.$router.push(item.path);
          }
        })
      },
      handleCommand(command) {
        if (command == 2) {
          this.logout();
        }
      },
      logout() {
        PostData({
          service: 'User.Auth.Logout',
          microservices: 'auth',
          access_token: getStorage('token'),
        }).then(res => {
          if (res.data.ret === 200) {
            var all = window.sessionStorage;
            for(var i=0;i<all.length;i++){
              if(all.key(i).indexOf("tjk")!="-1"){
                all.setItem(all.key(i),"");
              }
            }
            if (window.bc) {
              window.bc.postMessage(['closeAll', window.uuid]);
            }
            this.$router.push('/');
            sessionStorage.removeItem('is_open_audio');
            removeStorage('accid');
            if(Vue.prototype.nim) {
              Vue.prototype.nim.destroy({
                // 清除实例
                done(err) {
                  console.log("实例已被完全清除", err);
                },
              });
            }
            // window.sessionStorage['leftMenuShowHide'] = 0;
            // window.sessionStorage['topMenuId'] = this.menuList[0].id;
          }
        }).catch(error => console.log(error));
      },
    },
  }
</script>

<style lang="scss">
.l_accountTopNav_menu{
  .el-submenu,.el-menu-item{
    height: 50px !important;
    width: 172px;
    .el-submenu__title{
      height: 50px !important;
      line-height: 50px !important;
    }
  }
  .is-active{
    background-color: #409dfe !important;
    color: #fff !important;
    .el-submenu__title{
      background-color: #409dfe !important;
      color: #fff !important;
      i{
        color: #fff !important;
      }
    }
  }
}
  // .topmenu {
  //   .el-submenu.is-active,.el-menu-item.is-active {
  //     background: #409dfe !important;
  //     color: #fff !important;
  //     .el-submenu__title{
  //       background-color: #409dfe !important;
  //       color: #fff !important;
  //       i{
  //         color: #fff !important;
  //       }
  //     }
  //   }
  // }
  .el-dropdown {
    cursor: pointer;
    padding-right: 20px;
    float: right;
    .menuicon {
      display: inline-block;
      margin: 0 5px;
      vertical-align: middle;
      line-height: 50px;
      img {
        display: block;
        margin-top: -3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue